export const environment = {
  production: false,
  apiUrl: 'https://dev-api-payments.internal.courthousecomputersystems.com',
  payrocApplication: {
    appCode: 'ccs',
    apiKey: 'ccs-secret-key-2026',
  },
  paywireOSBPUrl: 'https://dbstage1.paywire.com/OSBP/pwosbp.aspx',
  paywireClientId: '0000012992',
  paywireKey: '9DFB8877-B4B3-4737-A9FD-5A04E9C215F7',
};
